import React from 'react'
import no_data from '../images/no_data.jpg'

const ErrorPage = () => {
    return <img className='no_data' src={no_data} alt='no_data' />
}

export default ErrorPage
